<template>
  <div>
    <div style="height:200px;">
      <div v-if="!signerInfo" class="text-center text-muted">
        İmzacı bilgileri alınıyor.
      </div>
      <div v-else>
        <table class="table table-sm table-borderless ozet">
          <tbody>
            <tr v-show="signerInfo.User">
              <td style="width:150px;">İmzacı</td>
              <td style="width:1px;">:</td>
              <td>{{ signerInfo.User.FullName }}</td>
            </tr>
            <tr>
              <td>Operatör</td>
              <td style="width:1px;">:</td>
              <td>{{ signerInfo.Operator }}</td>
            </tr>
            <tr>
              <td>Numara</td>
              <td style="width:1px;">:</td>
              <td>{{ signerInfo.Number }}</td>
            </tr>
          </tbody>
        </table>
        <div class="alert alert-danger" v-show="signerInfo.Error">
          {{ signerInfo.Error }}
        </div>
        <div v-if="item" class="text-center">
          <p>
            <strong>{{ item.FileName }}</strong>
          </p>
          <div v-if="item.Fingerprint">
            <p>
              <code>{{ item.Fingerprint }}</code>
            </p>
          </div>
          <div v-if="item.error"  class="alert alert-danger alert-dismissible d-flex align-items-center fade show" role="alert">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-exclamation-triangle flex-shrink-0 me-2" viewBox="0 0 16 16">
              <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>
            </svg>
             {{ item.error }}
            <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
          </div>
        </div>
      </div>
    </div>
    <div class="form-control" style="height:200px; overflow-y:auto; padding:0">
      <table class="table">
        <tbody>
          <div class="item-list">
            <table class="table table-borderless table-hover">
              <tbody>
                <tr v-for="i in items" :key="i.Id">
                  <td>
                    {{ i.FileName }}
                    <small class="text-muted">{{ i.Size | prettyBytes }}</small>
                  </td>
                  <td>{{ i.State }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import axios from "axios";

export default {
  components: {},
  props: {
    items: Array
  },
  data() {
    return {
      signerInfo: null, // İmzacı bilgileri
      jobInfo: null,     //İş bilgileri
      item: null, // Şu anda imzalanmakta olan dosya
      loading: false
    };
  },
  created() {
    axios
      .get("/mobilesign/signerinfo")
      .then(x => {
        this.signerInfo = x.data.Data;
        console.log("signerInfo:", this.signerInfo);
      })
      .catch(x => {
        this.signerInfo = {
          Error: "Mobil imza bilgileri alınamadı."
        };
        console.log("Mobil imza bilgileri alınamadı: ", x);
      });
  },
  methods: {
    setLoading(isLoading) {
      this.loading = isLoading;
      this.$emit("onloading", isLoading);
    },
    cancel() {
      this.canceled = true;
      this.setLoading(false);
    },
    signDocument(index) {
      this.item = this.items[index];

      this.item.State = "Parmakizi hesaplanıyor";
      this.item.error = "";

      axios
        .get(this.item.FingerprintUrl)
        .then(x => {
          console.log("Fingerprint result: ", x.data);
          if (x.data.Success) {
            this.item.Fingerprint = x.data.Data.Fingerprint;

            this.item.State = "İmza bekleniyor";
            this.$forceUpdate();

            var dataUrl = this.item.PostUrl.replace(
              "{0}",
              x.data?.Data?.FingerPrintTempFileId
            );
            console.log(dataUrl);

            setTimeout(() => {
              axios
                .get(dataUrl)
                .then(x => {
                  console.log("mobile sign result:", x.data);
                  if (x.data.Success) {
                    this.item.State = "Tamamlandı";
                    this.item.OK = true;

                    if (index + 1 < this.items.length) {
                      this.signDocument(index + 1);
                    } else {
                      this.$emit("completed", this.items);
                      this.setLoading(false);
                    }
                  }
                })
                .catch(x => {
                  console.log("Mobil imza başarısız: ", x);
                  this.item.error = x.response.data.ModelState.UserException[0];
                  this.item.State = "Başarısız";
                  this.item.Fingerprint = null;
                  this.item.OK = false;
                  this.setLoading(false);
                })
                .then(() => {
                  this.$forceUpdate();
                });
            }, 1500);
          } else {
            this.item.error = x.data.ErrorMessages;
          }
        })
        .catch(x => {
          this.item.error = x.response.data.ModelState.UserException[0];
          this.item.State = "Başarısız";
          this.setLoading(false);
          console.log("Parmak izi alınamadı: ", x);
        })
        .then(() => {
          this.$forceUpdate();
        });
    },
    sign() {
      this.setLoading(true);
      this.signDocument(0);
    }
  }
};
</script>
